import { useMutation, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface AccountExportFile {
  name: string
  url: string
}

export interface AccountExportResponse {
  files: AccountExportFile[]
  expires_in: number
  expires_at: string
}

export function useAccountExport(token: string) {
  return useQuery<AccountExportResponse, unknown>({
    queryKey: ['account_export', token],
    queryFn: () =>
      api.get<{ data: AccountExportResponse }>(`/api/account_export/${token}`).then(
        (res) => res.data.data,
      ),
    retry: false,
    staleTime: 0,
  })
}

export interface AccountExportRequest {
  id: number
  status: 'pending'
}

/**
 * EP-160 T160-104d/104w: the owner's "download all data" on Settings ->
 * ลบบัญชี. The server answers 202 and mails the link to the owner only;
 * 422 owner_email_recently_changed and 409 export_in_progress are the two
 * refusals. Nothing on screen is cached from it, so there is nothing to
 * invalidate.
 */
export function useRequestAccountExport() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await api.post<{ data: AccountExportRequest }>('/api/account_export')
      return data.data
    },
  })
}
